import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_AUTHORIZED_SERVICES](state, data) {
    console.log('mutation ', data)
    state.allAuthorizedServices = data
  },
  [types.SAVE_AUTHORIZED_SERVICE](state, data) {
    console.log('mutation ', data)
    state.authorizedService = data
  },
}
